"use client";

import React from "react";
import { ShieldCheck, Quote } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TrustAccountability() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="129534" id="our-registered-commitment" className="relative overflow-hidden bg-muted py-12 sm:py-16 md:py-20 lg:py-24">
      <div className="pointer-events-none absolute inset-0 opacity-[0.05]" style={{
      backgroundImage: "radial-gradient(circle at 2px 2px, var(--foreground) 2px, transparent 0)",
      backgroundSize: "48px 48px"
    }} aria-hidden="true" />

      <div ref={ref} className={`relative z-10 container mx-auto px-4 sm:px-6 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        <div className="mx-auto grid max-w-6xl items-center gap-10 md:grid-cols-2 lg:gap-16 xl:gap-20">
          <div className="flex justify-center md:justify-end">
            <Card className="group relative w-full max-w-md overflow-hidden rounded-2xl border-none bg-card/95 shadow-2xl backdrop-blur-md">
              <div className="absolute left-0 right-0 top-0 h-2 origin-left bg-secondary transition-transform group-hover:scale-x-100" />

              <CardContent className="flex flex-col items-center p-6 text-center sm:p-8 md:p-10 lg:p-12">
                <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-secondary/10 transition-transform duration-500 group-hover:rotate-0 sm:mb-8 sm:h-20 sm:w-20 rotate-3">
                  <ShieldCheck className="h-8 w-8 text-secondary sm:h-10 sm:w-10" strokeWidth={1.5} />
                </div>

                <h2 className="mb-3 font-sans text-2xl font-bold tracking-tight text-card-foreground sm:text-3xl">
                  UK Registered Charity
                </h2>

                <p className="mb-6 text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground sm:mb-8 sm:text-sm">
                  Regulated & Accountable
                </p>

                <div className="relative w-full overflow-hidden rounded-xl bg-primary px-4 py-4 text-primary-foreground shadow-lg sm:px-6">
                  <div className="absolute inset-0 bg-[linear-gradient(45deg,transparent_25%,rgba(255,255,255,0.1)_50%,transparent_75%,transparent_100%)] bg-[length:250%_250%,100%_100%] animate-[shimmer_3s_infinite]" />
                  <span className="mb-1 block text-[10px] font-mono uppercase tracking-widest opacity-90 sm:text-xs">
                    Charity Number
                  </span>
                  <span className="block font-mono text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl">
                    1214126
                  </span>
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="flex flex-col gap-6 px-2 sm:px-4 md:px-0">
            <Quote className="-mb-3 h-12 w-12 rotate-180 text-secondary/20 sm:-mb-4 sm:h-16 sm:w-16" aria-hidden="true" />

            <blockquote className="font-serif text-xl italic leading-tight text-foreground sm:text-2xl sm:leading-snug md:text-3xl lg:text-4xl">
              "Our commitment to transparency is as strong as our dedication to
              the children and communities we support in Ghana. Every donation
              is treated with care, accountability, and purpose."
            </blockquote>

            <div className="mt-2 flex items-center gap-4 sm:gap-5">
              <div className="flex h-12 w-12 items-center justify-center rounded-full border-2 border-secondary/20 bg-secondary/10 sm:h-14 sm:w-14">
                <span className="font-serif text-lg font-bold text-secondary sm:text-xl">
                  FF
                </span>
              </div>

              <div>
                <div className="text-base font-bold tracking-tight text-foreground sm:text-lg">
                  Board of Trustees
                </div>
                <div className="text-xs font-semibold uppercase tracking-wider text-secondary sm:text-sm">
                  Farquhar Fisher Foundation
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}